import { createApp } from 'vue'
import News from './News.vue'
import Post from './Post.vue'
import Posts from './Posts.vue'
import { createRouter, createWebHashHistory } from 'vue-router'

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        { name: 'posts', path: '/', component: Posts },
        { name: 'post', path: '/post/:id',  component: Post },
    ]
})

const app = createApp(News)
app.use(router)
app.mount('#news')
